import React, { Suspense, lazy, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import AppLayout from "./components/AppLayout";
import ContactPage from "./pages/ContactPage";
import DocumentsPage from "./pages/DocumentsPage";
import AchievementsPage from "./pages/AchievementsPage";
import AchievementDetailPage from "./pages/AchievementDetailPage";
import PricingPage from "./pages/PricingPage";
import ServicePage from "./pages/ServicePage";
import ServicesPage from "./pages/ServicesPage";
import ScrollToTop from "./components/ScrollToTop";
import ApiProvider from "./contexts/ApiProvider";
import { captureMarketingAttribution } from "./helpers/marketingAttribution";

const AdminRoot = lazy(() => import("./admin/AdminRoot"));

export default function App() {
  const location = useLocation();

  useEffect(() => {
    captureMarketingAttribution();
  }, [location.pathname, location.search]);

  return (
    <>
      <ApiProvider>
        <ScrollToTop />
        <Routes>
          <Route
            path="/admin/*"
            element={
              <Suspense
                fallback={
                  <div className="container py-10 text-center">
                    <span className="spinner-border text-primary" />
                  </div>
                }
              >
                <AdminRoot />
              </Suspense>
            }
          />
          <Route path="/" element={<AppLayout />}>
            <Route path="" element={<HomePage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="services/:slug" element={<ServicePage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="realisations" element={<AchievementsPage />} />
            <Route path="realisations/:slug" element={<AchievementDetailPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="pricing" element={<PricingPage />} />
          </Route>
        </Routes>
      </ApiProvider>
    </>
  );
}
